import { useState, useRef } from 'react';
import type { QuantAnalysisFilter } from '@trinity/chat/src/api/interfaces/projects.quant-analysis';
import { QuantAnalysisFilterContext } from './context';

export const QuantAnalysisFilterContainer = ({
  children,
  initialFilter,
}: {
  children: React.ReactNode;
  initialFilter?: { columnNames?: string[]; rowNames?: string[] };
}) => {
  const hasAppliedInitialFilter = useRef(false);

  const [quantFilter, setQuantFilter] = useState<QuantAnalysisFilter>(() => {
    if (initialFilter && !hasAppliedInitialFilter.current) {
      hasAppliedInitialFilter.current = true;
      const newFilter = {
        columnNames: initialFilter.columnNames || [],
        rowNames: initialFilter.rowNames || [],
        sortConfig: null,
        selection: {
          rows: new Set<number>(),
          columns: new Set<number>(),
          cells: new Map<string, boolean>(),
        },
        customColumnNames: new Map(),
        customRowNames: new Map(),
      };

      return newFilter;
    }

    return {
      columnNames: [],
      rowNames: [],
      sortConfig: null,
      selection: {
        rows: new Set<number>(),
        columns: new Set<number>(),
        cells: new Map<string, boolean>(),
      },
      customColumnNames: new Map(),
      customRowNames: new Map(),
    };
  });

  return (
    <QuantAnalysisFilterContext.Provider value={[quantFilter, setQuantFilter]}>
      {children}
    </QuantAnalysisFilterContext.Provider>
  );
};